<!-- =========================================================================================
  File Name: list.vue
  Description: Admin List
========================================================================================== -->

<template>
  <div id="admin-list">

    <vx-card title="管理员列表">

      <div slot="actions">
        <vs-button color="success" size="small" type="filled" @click="add">添加管理员</vs-button>
      </div>

      <vs-table stripe :data="list" noDataText="暂无管理员">
        <template slot="thead">
          <vs-th width="150">ID</vs-th>
          <vs-th width="300">用户名</vs-th>
          <vs-th width="450">登录时间</vs-th>
          <!-- <vs-th width="350">登录IP</vs-th> -->
          <vs-th>操作</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="index" v-for="(item, index) in list" >
            <vs-td :data="item.id">{{item.id}}</vs-td>
            <vs-td :data="item.username">{{item.username}}</vs-td>
            <vs-td :data="item.actionDate">{{item.loginDate}}</vs-td>
            <!-- <vs-td :data="item.loginIP">{{item.loginIP}}</vs-td> -->
            <vs-td>
              <vs-button color="primary" type="filled" size="small" @click="modify" :data-index="index">更改</vs-button>
              <vs-button color="danger" type="border" size="small" @click="del" :data-index="index" class="ml-5">删除</vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-pagination class="mt-6" :total="totalPage" v-model="page" goto />
    </vx-card>

    <!-- 更改侧边栏-->
    <modify-sider-bar ref="modifySiderBar" :title="modifyIndex != -1 ? '更改管理员信息' : '添加管理员'" @confirm="submit">
      <div class="p-4">
        <div class="mb-10">
          <vs-input class="w-full" v-model="modifyItem.username" label-placeholder="用户名" :disabled="modifyIndex != -1" />
        </div>
        <div class="mb-10">
          <vs-input class="w-full" v-model="modifyItem.password" label-placeholder="密码 (不更改请留空)" />
        </div>
        <div class="mb-4">
          <vs-input class="w-full" v-model="modifyItem.safecode" label-placeholder="安全码 (不更改请留空)" />
        </div>

        <vx-card title="权限设置" class="mt-4">
          <div class="mb-6" v-for="(item, index) in authorityList" :key="index" v-if="modifyItem.authority">
            <h5 class="mb-3">{{index}}</h5>
            <div class="flex items-center flex-wrap">
              <vs-checkbox class="w-32 mb-2" v-model="modifyItem.authority[index2]" v-for="(item2, index2) in item" :key="index2">{{item2}}</vs-checkbox>
            </div>
          </div>
        </vx-card>

      </div>
    </modify-sider-bar>
  </div>
</template>

<script>

import { Mandarin as flatPickrZh } from 'flatpickr/dist/l10n/zh.js'
import modifySiderBar from '../../layouts/components/modifySiderBar.vue'

export default {
  data() {
    return {
      page: 1,
      totalPage: 1,
      list: [],
      modifyIndex: 0,
      modifyItem: {},
      flatPickrConfig: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i:ss',
        locale: flatPickrZh
      },
      authorityList: []
    }
  },
  components: {
    modifySiderBar,
  },
  methods: {
    add () {
      this.modifyIndex = -1
      this.modifyItem = {}
      this.modifyItem.authority = {}
      this.$refs.modifySiderBar.open()
    },
    modify (e) {
      this.modifyIndex = e.currentTarget.dataset.index
      this.modifyItem = JSON.parse(JSON.stringify(this.list[parseInt(this.modifyIndex)]))
      this.modifyItem.password = ''
      this.modifyItem.safecode = ''
      this.modifyItem.authority = this.authorityFormat(this.modifyItem.authority)
      this.$refs.modifySiderBar.open()
    },
    submit () {
      const postdata = JSON.parse(JSON.stringify(this.modifyItem))
      postdata.authKey = localStorage.getItem('authKey')
      for (let i in postdata.authority) {
        postdata.authority[i] = postdata.authority[i] ? 1 : 0
      }
      postdata.authority = JSON.stringify(postdata.authority)
      this.$utils.post(this.modifyIndex === -1 ? 'admin-add' : 'admin-update', postdata).then(res => {
        this.$vs.dialog({
          title: '提示',
          text: res,
          acceptText: '确认'
        })
        if (this.list[this.modifyIndex]) {
          this.list[this.modifyIndex] = JSON.parse(JSON.stringify(this.modifyItem))
        } else {
          this.list.push(this.modifyItem)
        }
        this.$refs.modifySiderBar.close()
        this.$forceUpdate()
      })
    },
    del (e) {
      const index = e.currentTarget.dataset.index
      const postdata = {}
      postdata.id = this.list[index].id
      postdata.authKey = localStorage.getItem('authKey')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '确认',
        text: '确认删除该管理员吗?',
        acceptText: '确认',
        cancelText: '取消',
        accept: () => {
          this.$utils.post('admin-delete', postdata).then(res => {
            this.$vs.dialog({
              title: '提示',
              text: res,
              acceptText: '确认'
            })
            this.list.splice(index, 1)
          })
        }
      })
    },
    load() {
      this.$utils.post('admin-list', { page: this.page, authKey: localStorage.getItem('authKey') }).then(res => {
        this.list = res.list
        this.totalPage = Math.ceil(res.count / res.pagesize)
      })
    },
    authorityFormat (authority) {
      if (typeof authority === 'object') return authority
      try {
        authority = JSON.parse(authority)
      } catch (e) {
        authority = {}
      }
      return authority
    }
  },
  watch: {
    page(newValue, oldValue) {
      this.page = newValue
      this.load()
    }
  },
  mounted () {
    this.load()

    this.$utils.post('admin-authorityList', { authKey: localStorage.getItem('authKey') }).then(res => {
      this.authorityList = res
    })
  }
}
</script>
